// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Deposit_wrapper__1nsgK","flexWrapper":"Deposit_flexWrapper__1-VOl","formWrapper":"Deposit_formWrapper__FJyYb","tableWrapper":"Deposit_tableWrapper__1pHNl"};